/**
 * Decode a JWT payload without verifying the signature.
 *
 * Used only to read the routing metadata (api_base, project_id, read_only,
 * exp) on boot — the real signature check happens server-side when we POST
 * the token to /exchange. So this is intentionally not a verifier; trusting
 * unverified claims here is fine because we send the same token to the
 * backend, which won't honour it if the signature is bad.
 */
const base64UrlDecode = str => {
    const pad = '='.repeat((4 - (str.length % 4)) % 4);
    const b64 = (str + pad).replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(
        atob(b64)
            .split('')
            .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join('')
    );
};

const parseJwt = token => {
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('Malformed JWT');
    return JSON.parse(base64UrlDecode(parts[1]));
};

export default parseJwt;
